import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-cta-redesign',
  templateUrl: './cta-redesign.component.html',
  styleUrls: ['./cta-redesign.component.scss']
})
export class CtaRedesignComponent {

  @Input() title = '';
  @Input() description = '';

}